import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function ReportsIcon({
  style,
  width = 22,
  height = 22,
  onPress = () => {},
}) {
  return (
    <TouchableOpacity style={[style]} onPress={onPress}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7649 4.26313C9.07387 4.26313 7.70303 5.63397 7.70303 7.32498C7.70303 9.01598 9.07387 10.3868 10.7649 10.3868C12.0082 10.3868 13.0785 9.64571 13.558 8.58114C13.577 8.52466 13.5997 8.47024 13.6258 8.41812C13.7556 8.07862 13.8267 7.7101 13.8267 7.32498C13.8267 5.63397 12.4559 4.26313 10.7649 4.26313ZM10.7649 12.9131C12.7073 12.9131 14.4183 11.9221 15.4197 10.418L22.3068 11.8854C22.9891 12.0307 23.6601 11.5954 23.8054 10.9131C23.9508 10.2308 23.5155 9.55986 22.8332 9.4145L16.3097 8.02464C16.3383 7.79544 16.353 7.56193 16.353 7.32498C16.353 4.23872 13.8511 1.73682 10.7649 1.73682C7.67862 1.73682 5.17672 4.23872 5.17672 7.32498C5.17672 10.4112 7.67862 12.9131 10.7649 12.9131ZM5.5087 14.7219C5.12586 14.7163 4.76111 14.8846 4.51696 15.1795L0.526962 19.9995C0.214901 20.3765 0.148667 20.8998 0.356965 21.3426C0.565264 21.7855 1.01061 22.0681 1.49999 22.0681H13.14C13.5377 22.0681 13.9121 21.8809 14.1506 21.5627L17.6406 16.9077C17.9256 16.5276 17.9732 16.0198 17.7639 15.5934C17.5546 15.1669 17.1237 14.894 16.6487 14.8869L5.5087 14.7219ZM4.18543 19.5418L6.07683 17.257L14.1319 17.3763L12.5083 19.5418H4.18543Z"
          fill="url(#paint0_linear_reports)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_reports"
            x1="0.236816"
            y1="6.14602"
            x2="9.11122"
            y2="27.1914"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
